import React, { useState } from 'react';
import { FormControl, MenuItem, Select } from '@mui/material';
import { default as Grid } from '@material-ui/core/Grid';
import insightsStyles from './insightsStyles';
import PropTypes from 'prop-types';

export default function ToggleFilter({
	options,
	selectedBtn,
	onChange: newOnChange,
}) {
	const classes = insightsStyles();
	const [selected, setSelected] = useState(selectedBtn);

	const handleChange = (event) => {
		setSelected(event.target.value);
		newOnChange(event.target.value);
	};

	return (
		<Grid item xs={3} sm={3} md={3} lg={3}>
			<FormControl variant="standard">
				<Select
					data-test-id="location-table-selector"
					labelId="simple-select-retail-unit-label"
					id="simple-select-retail-unit"
					value={selected}
					onChange={handleChange}
					sx={{ fontSize: '14px' }}
					className={classes.select}
					MenuProps={{
						classes: { paper: classes.menuPaper },
						MenuListProps: {
							disablePadding: true,
						},
					}}
					disableUnderline>
					{options?.map((item, idx) => {
						return (
							<MenuItem
								data-test-id={`location-table-selector-item-${item}`}
								dense={true}
								sx={{
									display: item === selected ? 'none' : null,
									padding: '0 4px',
									fontFamily: 'Bogle-Regular',
									fontSize: '14px',
								}}
								key={`option-${idx}`}
								classes={{
									selected: classes.selected,
								}}
								value={item}>
								{item}
							</MenuItem>
						);
					})}
				</Select>
			</FormControl>
		</Grid>
	);
}

ToggleFilter.propTypes = {
	options: PropTypes.array,
	selectedBtn: PropTypes.string,
	onChange: PropTypes.func,
};
